import React from 'react';

import type { DepartmentId } from '@vlabs/api/artemy/model';
import { DeleteIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { deleteDepartments } from './deleteDepartments';
import { useDeleteDepartmentTranslation } from './i18n';
import type { DeleteDepartments } from './types';

interface DeleteDepartmentsIconButtonProps extends DeleteDepartments, Omit<IconButtonProps, 'onClick'> {
  departmentIds: [DepartmentId];
}
const displayName = 'DeleteDepartmentsIconButton';
const testid = buildTestid(displayName);

function DeleteDepartmentsIconButton({
  departmentIds,
  onDeleteDepartments = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: DeleteDepartmentsIconButtonProps): React.JSX.Element {
  const { t } = useDeleteDepartmentTranslation();

  return (
    <IconButton
      disabled={props.disabled ?? !departmentIds.length}
      icon={<DeleteIcon />}
      kind="negative"
      onClick={async () => deleteDepartments({ departmentIds, onDeleteDepartments })}
      shape="square"
      title={t('title')}
      {...testid(dataTestId)}
      {...props}
    />
  );
}

DeleteDepartmentsIconButton.displayName = displayName;

export { DeleteDepartmentsIconButton };
